import paymentHistoryCxcApi
  from "../api/paymentHistoryCxc.api";

const PaymentHistoryCxcService = {
  /**
   * 📄 Obtener historial de pagos
   * de una cuenta por cobrar
   *
   * GET /api/receivables/{id}/payment-history
   */
  getByReceivableId: async (
    receivableId: number
  ) => {
    const response =
      await paymentHistoryCxcApi.fetchCustom(
        `/${receivableId}/payment-history`
      );

    return response.data;
  },
};

export default PaymentHistoryCxcService;